var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 12.9585,
    width: 1.625,
    height: 11.9167,
    transform: "rotate(-180 13.5 12.9585)",
    fill: "#0F214F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45684 1.0415L4.30713 2.20723L8.13331 6.08669H0.5L0.5 7.91318L8.13321 7.91308L4.30713 11.7924L5.45684 12.9582L11.3333 6.99984L5.45684 1.0415Z",
    fill: "#0F214F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLast);
export default __webpack_public_path__ + "static/media/PageLast.1720caf4420f23f0b7cb5224df64b091.svg";
export { ForwardRef as ReactComponent };